import { useTu } from "@src/appV2/i18n/useTu";
import { Box, Stack } from "@mui/material";
import { Button } from "../../components/Button";
import { Text } from "../../components/Text";

export interface ChatErrorStateProps {
  /**
   * Optional custom error message. Defaults to a generic message.
   */
  message?: string;
  /**
   * Optional retry handler. If provided, shows a retry button.
   */
  onRetry?: () => void;
}

/**
 * Error state component for the chat panel.
 * Displays an error message and optional retry button when chat fails to load.
 */
export function ChatErrorState(props: ChatErrorStateProps) {
  const { tu } = useTu("chat");

  const { message = tu("Failed to load chat messages. Please try again."), onRetry } = props;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        padding: 4,
      }}
    >
      <Stack spacing={3} alignItems="center">
        <Text variant="body1" sx={(theme) => ({ color: theme.palette.error.main })}>
          {message}
        </Text>
        {onRetry && (
          <Button variant="outlined" onClick={onRetry}>
            {tu("Retry")}
          </Button>
        )}
      </Stack>
    </Box>
  );
}
